var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-world-leisure"},[_c('lucky-pet',{attrs:{"date":_vm.date,"client":_vm.client}}),(_vm.isCurrentWeek)?_c('furniture',{attrs:{"date":_vm.date,"client":_vm.client}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }